import { Analytics } from '@cld/unicorn-api';
import { ConsoleLogger } from '../state/types';

const convertGa4AdditionalInfo = (additionalInfo: string[] = []) =>
  additionalInfo.reduce<Record<`additional_info_${number}`, string>>((accumulator, entry, index) => {
    accumulator[`additional_info_${index + 1}`] = entry;
    return accumulator;
  }, {});

const convertGa4Levels = (levels: string[]) =>
  levels.reduce<Record<`level_${number}`, string>>((accumulator, entry, index) => {
    accumulator[`level_${index + 1}`] = entry;
    return accumulator;
  }, {});

export const createAnalytics = ({ consoleLogger }: { consoleLogger: ConsoleLogger }): Analytics => ({
  ga4: (eventData) => {
    window.dataLayer.push({
      event: 'ga4_event',
      event_name: eventData.eventName,
      ...convertGa4AdditionalInfo(eventData.additionalInfo),
      ...convertGa4Levels(eventData.levels),
      ...(eventData.actionLocation ? { action_location: eventData.actionLocation } : undefined),
    });

    consoleLogger.debug('analytics', 'Analytics event (ga4)', eventData);
  },
  universal: (eventData) => {
    window.dataLayer.push({
      event: 'event to GA',
      eventAction: eventData.action,
      eventCategory: eventData.category,
      eventLabel: eventData.label,
    });

    consoleLogger.debug('analytics', 'Analytics event (universal)', eventData);
  },
});
